import { Provider } from 'react-redux';
import { useStore } from '../config/store';
import { useRouter } from 'next/router';
import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';

const ENVIRONMENT = process.env.NODE_ENV || 'development';
const VERSION = process.env.VERSION || '1.0.0';

// Initialize Sentry on the client side only
if (typeof window !== 'undefined') {
  const SENTRY = process.env.SENTRY;
  
  Sentry.init({
    dsn: SENTRY,
    environment: ENVIRONMENT,
    release: `one21-web@${VERSION}`,
    integrations: [new Integrations.BrowserTracing()],
    // Set tracesSampleRate to 1.0 to capture 100% of transactions for performance monitoring
    // We recommend adjusting this value in production
    tracesSampleRate: ENVIRONMENT === 'production' ? 0.2 : 1.0,
    // Only send errors in production
    enabled: ENVIRONMENT === 'production',
    // Capture unhandled rejections and global errors
    autoSessionTracking: true,
  });
}

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';
import "../styles/index.scss";
import moment from 'moment';
moment.locale('id');
export default function App({ Component, pageProps }) {
  const router = useRouter();
  const store = useStore(pageProps.initialReduxState);

  return (
    <Provider store={store}>
      <Component {...pageProps} router={router} />

      <ToastContainer
        position="top-center"
        hideProgressBar={true}
        autoClose={3000}
        closeOnClick={false}
      />
    </Provider>
  );
}
